module.exports = __webpack_public_path__ + "img/828103897.ec46c055.jpg";